module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ka":{"symptoms":"სიმპტომები","answerdYes":"უპასუხა დადებითად","answerdNo":"უპასუხა უარყოფითად"},"en":{"symptoms":"Evidences","answerdYes":"Present","answerdNo":"Absent"}}')
  delete Component.options._Ctor
}
